import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69399a0bcbbd900013042f89_1782748374932_40c55d02/proximus_serviced_apartments/src/app/not-found.tsx");
